module.exports = __webpack_public_path__ + "fonts/ac765c3d/proxima_nova_reg-latin-a.ttf";